module.exports = __webpack_public_path__ + "static/a8-e5f16e6891a59a4ab02342635acee3b3.svg";